import * as React from 'react';

import { CompaniesList } from '../../components/companies-list';

export class AdminCompaniesPage extends React.Component {
  public render(): JSX.Element {
    return (
      <CompaniesList />
    );
  }
}
